import { ShipmentQuickFilters } from '../../../../models';

export const MILESTONES = [
  {
    active: false,
    name: ShipmentQuickFilters.Planned,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.InTransit,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.Departed,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.Arrived,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.Delivered,
    count: 0,
  },
];

export const DEVIATIONS = [
  {
    active: false,
    name: ShipmentQuickFilters.Early,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.InTime,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.AtRisk,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.Delay,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.AttentionNeeded,
    count: 0,
  },
];

export const INFOS = [
  {
    active: false,
    name: ShipmentQuickFilters.Message,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.Alert,
    count: 0,
  },
];
